import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PaymentStatus = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState('');
    const [bookingId, setBookingId] = useState(null);

    const paramBookingId = searchParams.get('booking_id');
    const paramOrderId = searchParams.get('order_id'); // Cashfree fallback
    const paramStatus = searchParams.get('status');
    const paramMessage = searchParams.get('message');

    useEffect(() => {
        if (paramStatus) {
            // Flow from Easebuzz callback redirect
            setStatus(paramStatus.toUpperCase());
            setMessage(paramMessage || (paramStatus === 'success' ? 'Payment Completed Successfully!' : 'Payment Failed.'));
            setBookingId(paramBookingId);
            setLoading(false);
        } else if (paramBookingId || paramOrderId) {
            // Flow where we only have IDs (maybe manual refresh)
            verifyPayment(paramBookingId || paramOrderId);
        } else {
            setLoading(false);
            setStatus('FAILED');
            setMessage('Invalid Payment Reference');
        }
    }, [paramBookingId, paramOrderId, paramStatus]);

    const verifyPayment = async (id) => {
        try {
            const payload = paramOrderId ? { order_id: id } : { booking_id: id };
            const res = await axios.post('/api/payment/verify-payment', payload);
            
            if (res.data.status === 'success') {
                setStatus('SUCCESS');
                setMessage('Payment Verified Successfully!');
                if (res.data.data && res.data.data.length > 0) {
                    setBookingId(res.data.data[0].booking_id);
                }
            } else if (res.data.status === 'pending') {
                setStatus('PENDING');
                setMessage('Payment Status is Pending. Please wait or check your profile.');
            } else {
                setStatus('FAILED');
                setMessage(res.data.message || 'Payment Verification Failed.');
            }
        } catch (error) {
            console.error("Verification Error:", error);
            setStatus('FAILED');
            setMessage('Error verifying payment status.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="container p-5 text-center" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <h3>Verifying Payment Status...</h3>
                <p className="text-muted">Please do not refresh or close this page.</p>
                <div className="spinner-border text-primary mt-3 mx-auto"></div>
            </div>
        );
    }

    return (
        <div className="container p-5 text-center" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className={`card shadow-lg p-5 mx-auto ${status === 'SUCCESS' ? 'border-success' : (status === 'PENDING' ? 'border-warning' : 'border-danger')}`} style={{ maxWidth: '600px', borderRadius: '20px' }}>
                <div className="mb-4">
                    {status === 'SUCCESS' ? (
                        <div className="display-1 text-success mb-3">✓</div>
                    ) : (status === 'PENDING' ? (
                        <div className="display-1 text-warning mb-3">!</div>
                    ) : (
                        <div className="display-1 text-danger mb-3">✕</div>
                    ))}
                </div>
                
                <h2 className={status === 'SUCCESS' ? 'text-success' : (status === 'PENDING' ? 'text-warning' : 'text-danger')}>
                    {status === 'SUCCESS' ? 'Payment Success!' : (status === 'PENDING' ? 'Payment Pending' : 'Payment Failed')}
                </h2>
                
                <p className="lead mt-3">{message}</p>
                
                {bookingId && <p className="fw-bold">Booking ID: {bookingId}</p>}
                
                <div className="mt-5 d-flex gap-3 justify-content-center">
                    <button className="btn btn-primary px-4 py-2 rounded-pill" onClick={() => navigate('/profile')}>
                        Go to Profile
                    </button>
                    <button className="btn btn-outline-secondary px-4 py-2 rounded-pill" onClick={() => navigate('/')}>
                        Go to Home
                    </button>
                </div>
                
                {status === 'SUCCESS' && (
                  <div className="mt-4 pt-3 border-top">
                    <p className="small text-muted">A confirmation SMS/WhatsApp with your receipt has been sent to your registered mobile number.</p>
                  </div>
                )}
            </div>
        </div>
    );
};

export default PaymentStatus;
